<div class="view-component">
    <div class="view-component-body">
        <div class="tem-card listoffile">
            <div class="tem-card__header">
                <span class="tem-card__title">{{'logaplicacao.title'|translateTA}}</span>
                <span class="header-info">
                    <label class="label1">{{'logaplicacao.lastUpdate'|translateTA}}: {{atualizacao}}</label>
                    <div class="tem-field time-field">
                        <input nz-input type="number" min="1"
                               [placeholder]="'logaplicacao.refreshTime'|translateTA"
                               nz-tooltip [nzTooltipTitle]="'logaplicacao.refreshTime'|translateTA"
                               [ngModel]="time | number:'1.0-0'"
                               pattern="[0-9]*"
                               (ngModelChange)="onTimeChange($event)"
                               numbersOnly>
                    </div>
                </span>
                <button nz-button nzType="primary" nzShape="circle" type="button" (click)="refresh()"
                        nz-tooltip [nzTooltipTitle]="'logaplicacao.refresh'|translateTA">
                    <nz-icon nzType="reload" />
                </button>
            </div>

            <div class="content">
                <ng-container *ngIf="(listOfFiles | async) as files">
                    <ul nz-list [nzDataSource]="files" nzSize="small" class="file-list">
                        <li nz-list-item *ngFor="let file of files" nzNoFlex>
                            <label nz-checkbox [ngModel]="isSelected(file)" (ngModelChange)="toggleFile(file, $event)">
                                <b>{{'logaplicacao.file'|translateTA}}: </b>{{file.filename}} -
                                <span class="file">{{'logaplicacao.size'|translateTA}}: </span> {{file.size}} MB -
                                <b>{{'logaplicacao.date'|translateTA}}:</b> {{file.lastchange}}
                            </label>
                        </li>
                    </ul>
                    <nz-empty *ngIf="files.length === 0" nzNotFoundImage="simple"
                              [nzNotFoundContent]="'logaplicacao.empty'|translateTA"></nz-empty>
                </ng-container>
            </div>

            <div class="actions">
                <button nz-button nzType="primary" type="button" (click)="download()" [disabled]="selectedFiles.length === 0">
                    <nz-icon nzType="download" />{{'logaplicacao.download'|translateTA}}
                </button>
            </div>
        </div>
    </div>
</div>
